import { Card } from '@faceup/ui'
import { Table } from '@faceup/ui-base'
import { generateShortIdUrl } from '@faceup/utils'
import { type FragmentType, getFragmentData, graphql } from '../__generated__'

const fragments = {
  ReportSourcesTable_reportSource: graphql(`
    fragment ReportSourcesTable_reportSource on ReportSource {
      id
      name
      isEnabled
      sourceType
      order {
        id
        status
      }
      shortLink
      hasActivePassword
      reportPassword
      createdByMember {
        id
        name
      }
    }
  `),
}

type ReportSourcesTableProps = {
  reportSources: FragmentType<typeof fragments.ReportSourcesTable_reportSource>[]
  loading: boolean
}

export const ReportSourcesTable = ({
  reportSources: _reportSources,
  loading,
}: ReportSourcesTableProps) => {
  const reportSources = getFragmentData(fragments.ReportSourcesTable_reportSource, _reportSources)

  return (
    <Card.Section>
      <Card.Header>Reporting forms</Card.Header>
      <Card.Content>
        <Table
          style={{ marginTop: 20 }}
          loading={loading}
          rowKey='id'
          dataSource={reportSources}
          locale={{ emptyText: ' ' }}
          scroll={{ x: 'max-content' }}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Type',
              dataIndex: 'sourceType',
              key: 'type',
            },
            {
              title: 'Has active password',
              key: 'hasActivePassword',
              render: ({ hasActivePassword }) => (hasActivePassword ? 'Yes' : 'No'),
            },
            {
              title: 'Created by',
              key: 'createdByMember',
              render: ({ createdByMember }) => createdByMember?.name ?? 'FaceUp Admin',
            },
            {
              title: 'Is enabled',
              key: 'isEnabled',
              render: ({ isEnabled }) => (isEnabled ? 'Yes' : 'No'),
            },
            {
              title: 'Password',
              dataIndex: 'reportPassword',
              key: 'password',
            },
            {
              title: 'Short link',
              key: 'shortLink',
              render: ({ shortLink }) => (
                <>
                  <a
                    target='_blank'
                    href={generateShortIdUrl(
                      import.meta.env.VITE_SHORTLINK_URL ?? '',
                      shortLink,
                      null
                    )}
                    rel='noreferrer noopener'
                  >
                    {generateShortIdUrl(import.meta.env.VITE_SHORTLINK_URL ?? '', shortLink, null)}
                  </a>
                </>
              ),
            },
          ]}
          pagination={false}
        />
      </Card.Content>
    </Card.Section>
  )
}
